import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28209612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "questionBox",
  id: "app"
}
const _hoisted_3 = { class: "questionContainer" }
const _hoisted_4 = { class: "title is-6" }
const _hoisted_5 = { class: "nav-dots" }
const _hoisted_6 = { class: "flex justify-center items-center" }
const _hoisted_7 = {
  class: "w-full max-w-xs flex flex-col py-5 px-8",
  action: ""
}
const _hoisted_8 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_9 = ["disabled", "placeholder"]
const _hoisted_10 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_11 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_12 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_13 = {
  class: "text-gray-700 font-bold py-2",
  for: "lyric_text"
}
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Lyric saved successfully!", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "questionFooter" }
const _hoisted_18 = {
  class: "pagination flex justify-between",
  role: "navigation",
  "aria-label": "pagination"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!

  return (_openBlock(), _createBlock(_component_vue_final_modal, {
    modelValue: _ctx.showModal,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showModal) = $event)),
    classes: "flex justify-center items-center",
    "content-class": "relative flex flex-col max-h-full mx-4 p-4 border dark:border-gray-800 rounded bg-white dark:bg-gray-900"
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_Transition, {
            "enter-active-class": "animated zoomIn",
            "leave-active-class": "animated zoomOut",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("header", null, [
                  _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.actions_add_lyric), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    "data-slide": "1",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 0}])
                  }, null, 2),
                  _createElementVNode("div", {
                    "data-slide": "2",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 1}])
                  }, null, 2)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["page p-8 hidden", {'page_active': _ctx.currentStep == 0}])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("form", _hoisted_7, [
                      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.labels_youtube_video_url), 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "text-gray-700 shadow border rounded border-gray-300 focus:outline-none focus:shadow-outline py-1 px-3 mb-3",
                        type: "text",
                        disabled: _ctx.isLoadingVideoInfo,
                        placeholder: _ctx.labels_input_youtube_url_placeholder,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerdata.videoUrl) = $event)),
                        onKeyup: _cache[1] || (_cache[1] = ({ target: { value } }) => _ctx.debounce(value)),
                        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getVideoInfo && _ctx.getVideoInfo(...args)))
                      }, null, 40, _hoisted_9), [
                        [_vModelText, _ctx.registerdata.videoUrl]
                      ]),
                      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.labels_song_title), 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "text-gray-700 shadow border rounded border-gray-300 focus:outline-none focus:shadow-outline py-1 px-3 mb-3",
                        type: "text",
                        placeholder: "",
                        disabled: "",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerdata.songTitle) = $event)),
                        onKeyup: _cache[4] || (_cache[4] = ({ target: { value } }) => _ctx.debounce(value))
                      }, null, 544), [
                        [_vModelText, _ctx.registerdata.songTitle]
                      ]),
                      _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.labels_band_name), 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "text-gray-700 shadow border rounded border-gray-300 mb-3 py-1 px-3 focus:outline-none focus:shadow-outline",
                        type: "text",
                        placeholder: "",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registerdata.bandName) = $event)),
                        onKeyup: _cache[6] || (_cache[6] = ({ target: { value } }) => _ctx.debounce(value))
                      }, null, 544), [
                        [_vModelText, _ctx.registerdata.bandName]
                      ]),
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.labels_youtube_video_id), 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "text-gray-700 shadow border rounded border-gray-300 focus:outline-none focus:shadow-outline py-1 px-3 mb-3",
                        type: "text",
                        placeholder: "",
                        disabled: "",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.registerdata.videoId) = $event)),
                        onKeyup: _cache[8] || (_cache[8] = ({ target: { value } }) => _ctx.debounce(value))
                      }, null, 544), [
                        [_vModelText, _ctx.registerdata.videoId]
                      ])
                    ])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["page p-8 hidden", {'page_active': _ctx.currentStep == 1}])
                }, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.labels_add_lyric), 1),
                  _createElementVNode("textarea", {
                    id: "lyric_text",
                    value: _ctx.lyric_text,
                    onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.parseLyricText && _ctx.parseLyricText(...args))),
                    rows: "30",
                    cols: "50"
                  }, null, 40, _hoisted_14)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["page p-8 hidden", {'page_active': _ctx.saved}])
                }, _hoisted_16, 2),
                _createElementVNode("footer", _hoisted_17, [
                  _createElementVNode("nav", _hoisted_18, [
                    _createElementVNode("button", {
                      class: "btn btn-secondary button order-first",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                    }, _toDisplayString(_ctx.actions_cancel), 1),
                    _createElementVNode("button", {
                      class: "btn button order-last",
                      disabled: _ctx.verifyingVideoExists || _ctx.videoExists,
                      onClick: _cache[11] || (_cache[11] = async (e)=> {await _ctx.nextStep()})
                    }, [
                      (_ctx.currentStep == 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.actions_continue), 1)
                          ], 64))
                        : (_ctx.currentStep == 1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.isSaving)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.actions_save), 1)
                                  ], 64))
                            ], 64))
                          : _createCommentVNode("", true)
                    ], 8, _hoisted_19)
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}